import React, { Component, useState } from 'react';
import { Modal } from 'bootstrap';
import { KTSVG } from '../../../../_metronic/helpers';

class SubGraficoModal extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState
        this.Show = (title) => {
            setTimeout(() => {
                var myModal = new Modal(document.getElementById(this.props.idModal), {
                    keyboard: false
                });
                this.setState({ show: true, title: title });
                myModal.show();
            })
        }
    }
    initialState = {
        show: false,
        title: '',
    }

    closeModal = () => {
        setTimeout(() => {
            this.setState(this.initialState);
        }, 1000)
    }

    render() {
        const { show, title } = this.state;
        const { children, idModal } = this.props;

        const openned = show ? {} : { display: 'none' }

        return (
            <div style={openned} className="modal fade" tabIndex={-1} id={idModal} width={'500px'} >
                <div className={"modal-dialog modal-xl"}  >
                    <div className="modal-content ">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                            {children}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-bs-dismiss="modal"
                                onClick={this.closeModal}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default SubGraficoModal;